<script setup lang="ts">
import { computed } from 'vue';
import { useToast } from './useToast';
import type { ToastPosition } from './useToast';
import ItpToast from './ItpToast.vue';

const props = withDefaults(defineProps<{ position?: ToastPosition }>(), {
  position: 'top-end',
});

const { toasts, remove } = useToast();

const positionClass = computed(() => {
  const [vertical, horizontal] = props.position.split('-');

  return {
    'toast-container': true,
    'position-fixed': true,
    'p-3': true,
    // Vertical
    'top-0': vertical === 'top',
    'top-50': vertical === 'middle',
    'bottom-0': vertical === 'bottom',
    'translate-middle-y': vertical === 'middle',
    // Horizontal
    'start-0': horizontal === 'start',
    'start-50': horizontal === 'center',
    'end-0': horizontal === 'end',
    'translate-middle-x': horizontal === 'center',
  };
});

const filteredToasts = computed(() => {
  return toasts.value.filter((t) => t.position === props.position);
});
</script>

<template>
  <div :class="positionClass" style="z-index: 1090">
    <TransitionGroup name="toast">
      <ItpToast
        v-for="toast in filteredToasts"
        :key="toast.id"
        :toast="toast"
        class="mb-2"
        @close="remove(toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>
